import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import * as Yup from "yup";
import {
  ErrorUnexpected,
  OperationSuccessfully,
} from "../../../../../../const/Messages";
import * as DocumentSectionService from "../../../../../../service/DocumentSectionService";
import Loading from "../../../../../Common/Loading/Loading";

const initialValues = {
  img: "",
  title: "",
};

const schema = Yup.object().shape({
  title: Yup.string().required("* Title is a required field"),
  img: Yup.string().required("* Upload Image is a required field"),
});

export default function SectionRegister({ location }) {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState(initialValues);
  const sectionId = location?.state?.id;

  useEffect(() => {
    if (sectionId) {
      DocumentSectionService.getById(sectionId)
        .then((section) => {
          setValues(section);
          setLoading(false);
        })
        .catch(() => {
          history.push("/settings/document/section", {
            message: ErrorUnexpected,
            messageType: "error",
          });
        });
    } else {
      setLoading(false);
    }
  }, [sectionId, history, location]);

  const handleImageChange = (event, setFieldValue) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (reader.result && typeof reader.result === "string") {
          setFieldValue("img", reader.result);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSave = (values, actions) => {
    DocumentSectionService.merge(sectionId, values)
      .then(() => {
        history.push("/settings/document/section", {
          message: OperationSuccessfully,
          messageType: "success",
        });
      })
      .catch((error) => {
        const errorMsg = error?.response?.data?.title || ErrorUnexpected;
        actions.setFieldError("title", errorMsg);
        actions.setSubmitting(false);
      });
  };

  const handleDelete = (id) => {
    Swal.fire({
      icon: "warning",
      title: "Confirmation",
      text: "Are you sure you want to delete?",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        DocumentSectionService.deleteById(id)
          .then(() => {
            history.push("/settings/document/section", {
              message: OperationSuccessfully,
              messageType: "success",
            });
          })
          .catch((error) => {
            const errorMsg = error?.response?.data?.title || ErrorUnexpected;
            toast.error(errorMsg ? errorMsg : ErrorUnexpected);
          });
      }
    });
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <Row>
      <Col>
        <div className="ibox">
          <div className="ibox-title">
            <h5>{sectionId ? "Edit Section" : "Register Section"}</h5>
          </div>
          <div className="ibox-content">
            <Formik
              enableReinitialize
              initialValues={values}
              validationSchema={schema}
              onSubmit={handleSave}
            >
              {({ values, setFieldValue, isSubmitting }) => (
                <Form>
                  {/* Title Field */}
                  <div className="form-group row">
                    <label className="col-form-label col-md-3">Title:</label>
                    <div className="col-md-6">
                      <Field
                        className="form-control"
                        name="title"
                        type="text"
                        placeholder="Title"
                      />
                      <span className="text-danger">
                        <ErrorMessage name="title" />
                      </span>
                    </div>
                  </div>

                  {/* Image Upload */}
                  <div className="form-group row">
                    <label className="col-form-label col-md-3">
                      Upload Image:
                    </label>
                    <div className="col-md-6">
                      <Button
                        variant="secondary"
                        onClick={() =>
                          document.getElementById("fileInput").click()
                        }
                      >
                        Select Image
                      </Button>
                      <input
                        id="fileInput"
                        name="img"
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={(e) => handleImageChange(e, setFieldValue)}
                      />
                      <ErrorMessage
                        name="img"
                        component="div"
                        className="text-danger"
                      />

                      {values.img && (
                        <div style={{ marginTop: "10px" }}>
                          <img
                            src={values.img}
                            alt="Preview"
                            style={{ maxWidth: "150px", borderRadius: "8px" }}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="d-flex justify-content-end">
                    <Link
                      className="btn btn-secondary mr-2"
                      to="/settings/document/section"
                    >
                      Cancel
                    </Link>

                    {sectionId && (
                      <Button
                        variant="danger"
                        className="mr-2"
                        onClick={() => handleDelete(sectionId)}
                        disabled={isSubmitting}
                      >
                        Delete
                      </Button>
                    )}

                    <Button
                      variant="primary"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {sectionId ? "Update" : "Save"}
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </Col>
    </Row>
  );
}
